import { Component, Input, OnInit } from "@angular/core";
import { IShellService } from "@tylertech/incode-module";
import { IntentService } from "@tylertech/intents-module";
import { ChartConfiguration } from "chart.js";
import { PacketProgress } from "../../../interfaces";

@Component({
    selector: "packet-progress-chart",
    templateUrl: "./packetProgressChart.tmpl.html",
    styleUrls: [
        "./packetProgressChart.component.scss"
    ],
    standalone: false
})
export class PacketProgressChartComponent implements OnInit
{
    chartConfig: ChartConfiguration<"bar">;

    @Input() item: PacketProgress;

    constructor(
        private readonly $shellService: IShellService,
        private readonly $intentService: IntentService
    ) { }

    ngOnInit(): void
    {
        this.displayChart();
    }

    private displayChart(): void
    {
        this.chartConfig = {
            type: "bar",
            options: {
                indexAxis: "y",
                plugins: {
                    legend: { display: false },
                    tooltip: { enabled: false },
                },
                scales: {
                    x: {
                        type: "linear",
                        stacked: true,
                        grid: { display: true },
                        min: 0,
                        max: 100,
                        ticks: {
                            stepSize: 25,
                        },
                    },
                    y: { stacked: true },
                },
            },
            data: {
                labels: [],
                datasets: [{
                    data: [(this.item.CompletedSteps / this.item.TotalSteps) * 100],
                    backgroundColor: ["#3F51B5"],
                }],
            },
        };
    }

    openPacket(): void
    {
        if (this.$shellService.isEmbedded())
        {
            this.$shellService.openShellFunction("OpenProcessing", this.item.ProcessId, false, "Failed to open packet ");
        }
        else
        {
            this.$intentService.resolveIntent({
                MIME: "OpenProcessing",
                Action: "Open",
                Data: { ProcessId: this.item.ProcessId },
            }, true);
        }
    }
}
